export const isMobile = (device: 'mobile' | 'tablet') => {
  const devices = {
    mobile: '(max-width: 767px)',
    tablet: 'only screen and (min-width: 768px)  and (max-width: 991px)',
  };

  return window.matchMedia(devices[device]).matches;
};

export const isdeviceUpToTablet = () => isMobile('mobile') || isMobile('tablet');
